module.exports = __webpack_public_path__ + "media/images/task-f6b79ed10b1216b85d942aefe4ab8b07.png";